export const AVATAR_URL =
  "https://static.prod-images.emergentagent.com/jobs/afb80a4d-d908-411d-b5b8-a3fc57b2aef4/images/2a749c51c2a2d6f390a1a66556ea0e7ba3631c99972112420493312357543416.png";
